module.exports = "//static.hsappstatic.net/ContentComponents/static-2.69719/img/landing-page-zero.png"